import React from "react";
import { Text, StyleSheet, View, TouchableOpacity } from "react-native";

import Loader from "../../../components/src/Loader";
import SocialMediaAccountWebController, {
  Props,
} from "../../social-media-account/src/SocialMediaAccountWebController";

const configJSON = require("./config.js");

import CustomFacebookLogInButton from "../../social-media-account/src/CustomFacebookLogInButton";
import CustomGoogleLogInButton from "../../social-media-account/src/CustomGoogleLogInButton";

// Customizable Area Start
// Customizable Area End

class SocialMediaAccountRegistrationScreen extends SocialMediaAccountWebController {
  static SocialMediaAccountRegistrationScreen: SocialMediaAccountRegistrationScreen;

  constructor(props: Props) {
    super(props);

    this.state = {
      // Customizable Area Start
      loading: false,
      isRegistration: true
      // Customizable Area End
    };
  }

  render() {
    // Customizable Area Start
    const { loading } = this.state;
    return (
      <View style={styles.container}>
        <Loader loading={loading} />
        {/* Merge Engine UI Engine Code */}
        <Text
          style={styles.labelTitle} //UI Engine::From Sketch
        >
          {configJSON.signUpTitleText} {/*UI Engine::From Sketch*/}
        </Text>

        <Text
          style={styles.titleWhySignUp} //UI Engine::From Sketch
        >
          {configJSON.signUpBodyText} {/*UI Engine::From Sketch*/}
        </Text>

        <CustomFacebookLogInButton
          testID="btnFacebookLogIn" //Merge Engine::From BDS
          appId="170982444234877" //Merge Engine::From SDS
          loginFacebookButtonText={configJSON.facebookButtonText} //UI Engine::From Sketch
          {...this.btnFacebookLogInProps} //Merge Engine::From BDS - {...this.testIDProps}
        />

        <CustomGoogleLogInButton
          testID="btnGoogleLogIn" //Merge Engine::From BDS
          style={styles.googleStyle} //UI Engine::From Sketch
          {...this.btnGoogleLogInProps} //Merge Engine::From BDS - {...this.testIDProps}
        />

        <Text
          style={styles.orTextStyle} //UI Engine::From Sketch
        >
          {configJSON.orText} {/*UI Engine::From Sketch*/}
        </Text>

        <View
          style={styles.logInButtonContainer} //UI Engine::From Sketch
        >
          <TouchableOpacity
            testID="btnNavigate" //Merge Engine::From BDS
            style={styles.signUpButtonStyle} //UI Engine::From Sketch
            {...this.btnNavigateProps} //Merge Engine::From BDS - {...this.testIDProps}
          >
            <Text
              style={styles.signUpButtonTextStyle} //UI Engine::From Sketch
            >
              {configJSON.signUpButtonText} {/*UI Engine::From Sketch*/}
            </Text>
          </TouchableOpacity>
        </View>
        {/* Merge Engine End UI Engine Code */}
      </View>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F5FCFF",
    alignItems: "center",
  },
  logInButtonContainer: {
    overflow: "hidden",
    flexDirection: "row",
    flexWrap: "wrap",
    display: undefined,
    alignContent: "flex-start",
    alignItems: "center",
    justifyContent: "center",
    shadowOpacity: 0.3,
    shadowRadius: 8,
    shadowColor: "black",
    width: 205,
    marginTop: 16,
    height: 40,
    elevation: 6,
    backgroundColor: "#ffffff"
  },
  facebookStyle: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    shadowColor: "black",
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
    borderWidth: 0,
    backgroundColor: "#ffffff",
    borderRadius: 0,
    padding: "11px"
  },
  facebookImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
  },
  facebookTextStyle: {
    fontFamily: "Inter, sans-serif",
    color: "#2553b4",
    paddingLeft: 7
  },
  googleStyle: {
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "black",
    flexDirection: "row",
    shadowOpacity: 0.3,
    borderWidth: 0,
    elevation: 6,
    shadowRadius: 8,
    backgroundColor: "#ffffff",
    borderRadius: 5,
    marginTop: 32,
  },
  googleButtonImageStyle: {
    width: 20,
    marginRight: 15,
    height: 20
  },
  googleButtonTextStyle: {
    paddingRight: 3,
    color: "#2553b4",
    fontSize: 14,
    paddingLeft: 6,
    marginLeft: 8,
    fontFamily: "Inter, sans-serif",
  },
  orTextStyle: {
    fontWeight: "bold",
    color: "#000000",
    margin: 20,
    alignSelf: "center",
  },
  signUpButtonStyle: {
    flexDirection: "row",
    shadowColor: "black",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0,
    shadowOpacity: 0.3,
    shadowRadius: 8,
    borderRadius: 0,
    backgroundColor: "#ffffff",
    elevation: 6,
    height: "100%",
    width: "100%",
    padding: "11px",
  },
  signUpButtonTextStyle: {
    fontSize: 11,
    color: "#2553b4",
    fontFamily: "Inter, sans-serif"
  },
  titleWhySignUp: {
    textAlign: "left",
    fontSize: 16,
    marginBottom: 32,
    marginVertical: 8
  },
  labelTitle: {
    marginBottom: 32,
    fontSize: 32,
    marginTop: 24,
    marginVertical: 8,
    textAlign: "left",
    color: "#6200EE"
  }
});
// Customizable Area End

export default SocialMediaAccountRegistrationScreen;
